module.exports = __webpack_public_path__ + "static/media/pexels-pixabay-373543_2.6ee188a6.jpg";